// Towns of Bulgaria. Cities are stored with these exact names so that filters always match.
// The same list lives in the mobile app, the web panel and the API - keep the three in sync.
export const BG_CITIES = [
  "Айтос",
  "Аксаково",
  "Алфатар",
  "Антоново",
  "Априлци",
  "Ардино",
  "Асеновград",
  "Ахелой",
  "Ахтопол",
  "Балчик",
  "Банкя",
  "Банско",
  "Баня",
  "Батак",
  "Батановци",
  "Белене",
  "Белица",
  "Белово",
  "Белоградчик",
  "Белослав",
  "Берковица",
  "Благоевград",
  "Бобов дол",
  "Бобошево",
  "Божурище",
  "Бойчиновци",
  "Болярово",
  "Борово",
  "Ботевград",
  "Брацигово",
  "Брегово",
  "Брезник",
  "Брезово",
  "Брусарци",
  "Бургас",
  "Бухово",
  "Българово",
  "Бяла",
  "Бяла Слатина",
  "Бяла черква",
  "Варна",
  "Велики Преслав",
  "Велико Търново",
  "Велинград",
  "Ветово",
  "Ветрен",
  "Видин",
  "Враца",
  "Вълчедръм",
  "Вълчи дол",
  "Върбица",
  "Вършец",
  "Габрово",
  "Генерал Тошево",
  "Главиница",
  "Глоджево",
  "Годеч",
  "Горна Оряховица",
  "Гоце Делчев",
  "Грамада",
  "Гулянци",
  "Гурково",
  "Гълъбово",
  "Две могили",
  "Дебелец",
  "Девин",
  "Девня",
  "Джебел",
  "Димитровград",
  "Димово",
  "Добринище",
  "Добрич",
  "Долна Митрополия",
  "Долна Оряховица",
  "Долна баня",
  "Долни Дъбник",
  "Долни чифлик",
  "Доспат",
  "Драгоман",
  "Дряново",
  "Дулово",
  "Дунавци",
  "Дупница",
  "Дългопол",
  "Елена",
  "Елин Пелин",
  "Елхово",
  "Етрополе",
  "Завет",
  "Земен",
  "Златарица",
  "Златица",
  "Златоград",
  "Ивайловград",
  "Игнатиево",
  "Искър",
  "Исперих",
  "Ихтиман",
  "Каблешково",
  "Каварна",
  "Казанлък",
  "Калофер",
  "Камено",
  "Каолиново",
  "Карлово",
  "Карнобат",
  "Каспичан",
  "Кермен",
  "Килифарево",
  "Китен",
  "Клисура",
  "Кнежа",
  "Козлодуй",
  "Койнаре",
  "Копривщица",
  "Костандово",
  "Костенец",
  "Костинброд",
  "Котел",
  "Кочериново",
  "Кресна",
  "Криводол",
  "Кричим",
  "Крумовград",
  "Крън",
  "Кубрат",
  "Куклен",
  "Кула",
  "Кърджали",
  "Кюстендил",
  "Левски",
  "Летница",
  "Ловеч",
  "Лозница",
  "Лом",
  "Луковит",
  "Лъки",
  "Любимец",
  "Лясковец",
  "Мадан",
  "Маджарово",
  "Малко Търново",
  "Мартен",
  "Мездра",
  "Мелник",
  "Меричлери",
  "Мизия",
  "Момин проход",
  "Момчилград",
  "Монтана",
  "Мъглиж",
  "Неделино",
  "Несебър",
  "Николаево",
  "Никопол",
  "Нова Загора",
  "Нови Искър",
  "Нови пазар",
  "Обзор",
  "Омуртаг",
  "Опака",
  "Оряхово",
  "Павел баня",
  "Павликени",
  "Пазарджик",
  "Панагюрище",
  "Перник",
  "Перущица",
  "Петрич",
  "Пещера",
  "Пирдоп",
  "Плачковци",
  "Плевен",
  "Плиска",
  "Пловдив",
  "Полски Тръмбеш",
  "Поморие",
  "Попово",
  "Пордим",
  "Правец",
  "Приморско",
  "Провадия",
  "Първомай",
  "Раднево",
  "Радомир",
  "Разград",
  "Разлог",
  "Ракитово",
  "Раковски",
  "Рила",
  "Роман",
  "Рудозем",
  "Русе",
  "Садово",
  "Самоков",
  "Сандански",
  "Сапарева баня",
  "Свети Влас",
  "Свиленград",
  "Свищов",
  "Своге",
  "Севлиево",
  "Сеново",
  "Септември",
  "Силистра",
  "Симеоновград",
  "Симитли",
  "Славяново",
  "Сливен",
  "Сливница",
  "Сливо поле",
  "Смолян",
  "Смядово",
  "Созопол",
  "Сопот",
  "София",
  "Средец",
  "Стамболийски",
  "Стара Загора",
  "Стражица",
  "Стралджа",
  "Стрелча",
  "Суворово",
  "Сунгурларе",
  "Сухиндол",
  "Съединение",
  "Сърница",
  "Твърдица",
  "Тервел",
  "Тетевен",
  "Тополовград",
  "Троян",
  "Трън",
  "Тръстеник",
  "Трявна",
  "Тутракан",
  "Търговище",
  "Угърчин",
  "Хаджидимово",
  "Харманли",
  "Хасково",
  "Хисаря",
  "Цар Калоян",
  "Царево",
  "Чепеларе",
  "Червен бряг",
  "Черноморец",
  "Чипровци",
  "Чирпан",
  "Шабла",
  "Шивачево",
  "Шипка",
  "Шумен",
  "Ябланица",
  "Якоруда",
  "Ямбол",
];

const CYRILLIC_TO_LATIN: { [letter: string]: string } = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sht",
  ъ: "a",
  ь: "y",
  ю: "yu",
  я: "ya",
};

// Comparable key for a city typed in latin or cyrillic: "София", "Sofia" and "sofiya" all give "sofia"
export const getCityKey = (city?: string | null) =>
  (city || "")
    .toLowerCase()
    .split("")
    .map((letter) => CYRILLIC_TO_LATIN[letter] ?? letter)
    .join("")
    .replace(/kh/g, "h")
    .replace(/y/g, "i")
    .replace(/ii/g, "i")
    .replace(/[^a-z]/g, "");

const CITY_BY_KEY = new Map(
  BG_CITIES.map((city) => [getCityKey(city), city] as [string, string]),
);

// The official name of a town however it was typed, or null when it is not in the list
export const findCity = (city?: string | null) =>
  CITY_BY_KEY.get(getCityKey(city)) || null;

// Official name when the town is known, otherwise the trimmed input (villages are not in the list)
export const normalizeCity = (city?: string | null) =>
  findCity(city) || (city || "").trim();
